'use client';
import { createContext } from '../../utils/component.context';
export const [ContextMenuProvider, useContextMenu] = createContext({
    name: 'ContextMenuContext',
    hookName: 'useContextMenu',
    strict: true,
    providerName: 'ContextMenuProvider',
});
export const [ContextMenuGroupProvider, useContextMenuGroup] = createContext({
    name: 'ContextMenuGroupContext',
    hookName: 'useContextMenuGroup',
    providerName: 'ContextMenuGroupProvider',
    strict: true,
    defaultValue: {
        type: 'neutral',
    },
});
